import { percentToDecimal } from '@calculations/decimal/percent';

import { onPartBaseGrossMarginChange } from '../../calculations/recalculate';
import { validateGrossMargin } from '../../validations/gross-margin';
import { PriceFieldHandlerParams } from './types';

export function handlePartBaseGrossMarginChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
  priceStrategyConfigs,
}: PriceFieldHandlerParams) {
  const baseGrossMarginPercent = validateGrossMargin(state, {
    grossMargin: value,
    quoteLineUuid,
    quotePriceUuid,
    field: 'baseGrossMargin',
  });

  if (!baseGrossMarginPercent) {
    return;
  }

  const baseGrossMargin = percentToDecimal(baseGrossMarginPercent);

  onPartBaseGrossMarginChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    baseGrossMargin,
    priceStrategyConfigs,
  });
}

// @NOTE(mrs): Service charges do not have a base gross margin
